import React from 'react'

const OPTIONS = [
    { value: 'all', label: 'Все товары' },
    { value: 'visible', label: 'Только видимые' },
    { value: 'hidden', label: 'Только скрытые' },
]

const ContainerButtonVisible = ({
    value = 'all',
    onChange,
}) => {
    return (
        <div className="containerButtonVisible">
            <div
                className="containerButtonVisible__row"
                role="group"
                aria-label="Фильтр видимости товаров"
            >
                {OPTIONS.map((item) => {
                    const isActive = value === item.value

                    return (
                        <button
                            key={item.value}
                            type="button"
                            className={`containerButtonVisible__box ${isActive ? 'active' : ''}`}
                            aria-pressed={isActive}
                            onClick={() => onChange?.(item.value)}
                        >
                            {item.label}
                        </button>
                    )
                })}
            </div>
        </div>
    )
}

export default ContainerButtonVisible
